import Vue from "vue";
import Vuex from "vuex";
import { getAuthInfoApi, getIndexSettingApi } from "@/api/api";

Vue.use(Vuex);

const state = {
  token: localStorage.getItem("token") || "",
  settingInfo: JSON.parse(localStorage.getItem("settingInfo") || "null"),
  userInfo: JSON.parse(localStorage.getItem("userInfo") || "null"),
  languageInfo: JSON.parse(localStorage.getItem("languageInfo") || "null")
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
    localStorage.setItem("token", token);
  },
  SET_SETTING_INFO: (state, settingInfo) => {
    state.settingInfo = settingInfo;
    localStorage.setItem("settingInfo", JSON.stringify(settingInfo));
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
  },
  SET_LANGUAGE_INFO: (state, languageInfo) => {
    state.languageInfo = languageInfo;
    localStorage.setItem("languageInfo", JSON.stringify(languageInfo));
  },
  CLEAR_USER: (state) => {
    state.token = "";
    state.userInfo = null;
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
  },
};

const actions = {
  // 获取配置
  async getSettingInfo({ commit }) {
    const settingInfo = await getIndexSettingApi();
    commit("SET_SETTING_INFO", settingInfo.data);
    return settingInfo;
  },

  // 获取用户信息
  async getUserInfo({ commit, state }) {
    if (!state.token) {
      throw new Error("token不存在");
    }
    const userInfo = await getAuthInfoApi();
    commit("SET_USER_INFO", userInfo.data);
    return userInfo;
  },

  // 退出登录
  logout({ commit }) {
    commit("CLEAR_USER");
  },
};

export default new Vuex.Store({
  state,
  mutations,
  actions
});
